export const apiHub = {

    // Data for merchantCheck API call.
    merchantCheck: {
        method: "POST",
        apiUrl: "api/merchant/check"
    },

    // Data for accounts API call.
    accounts: {
        method: "GET",
        apiUrl: "api/accounts"
    },

    // Data for token invalidation API call.
    invalidateToken: {
        method: "DELETE",
        apiUrl: "api/auth/token/invalidate"
    },

    // Refresh token.
    refreshToken: {
        method: "GET",
        apiUrl: "api/time"
    },

    // Our very own node server call.
    getMcParams: {
        method: "GET",
        apiUrl: "api/getMerchantData"
    },

    // Signing operation data.
    getSignId: {
        method: "POST",
        apiUrl: "api/payment"
    },

    // Signing request aborted.
    deleteSignRequest: {
        method: "DELETE",
        apiUrl: "api/payment/sign/%signId%"
    },

    // Payment check API call.
    paymentCheck: {
        method: "GET",
        apiUrl: "api/payment/check/%transactionId%"
    },

    // Signing step 1.
    signingStep1: {
        method: "GET",
        apiUrl: "api/payment/sign/%iban%"
    },

    // Signing step 2.
    signingStep2: {
        method: "POST",
        apiUrl: "api/payment/sign/%signId%",
        messageBody: {
            authorizationType: "%authType%",
        }
    },

    //  Signing step 3.
    signingStep3: {
        method: "PUT",
        apiUrl: "api/payment/sign/%signId%"
    },

    // Create log.
    log: {
        method: "POST",
        apiUrl: "api/log"
    },

    // Get SecV url.
    login: {
        method: "GET",
        apiUrl: "api/login"
    },

    // Environments.
    env: {
        list: ["slsp.localhost", "uat1", "uat3", "dit3", "perf", "uat", "fix", "fat", "sit"],
        urls: {
            "slsp.localhost": "/",
            "uat1": "https://api-uat1.slsp.sk/sporopay/",
            "uat3": "https://api-uat3.slsp.sk/sporopay/",
            "dit3": "https://api-dit3.slsp.sk/sporopay/",
            "perf": "https://api-perf.slsp.sk/sporopay/",
            "prod": "https://api.slsp.sk/sporopay/",
            "uat": "https://api-uat.slsp.sk/sporopay/",
            "fix": "https://api-fix.slsp.sk/sporopay/",
            "fat": "https://api-fat.slsp.sk/sporopay/",
            "sit": "https://api-sit.slsp.sk/sporopay/"
        },
    },
}
